import React, { Component } from 'react';
import { Grid, Card, Image, Label } from 'semantic-ui-react';
import moment from 'moment';

import placeholder from '../assets/profile-placeholder.png';
import { reduce } from 'lodash';

 export default class InmateGridItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const displayImage = true;
        const displayText = true;
        let fullName = '';
        if (this.props.inmate.FirstName) fullName = this.props.inmate.FirstName;
        if (this.props.inmate.MiddleName) fullName += ` ${this.props.inmate.MiddleName}`;
        if (this.props.inmate.LastName) fullName += ` ${this.props.inmate.LastName}`;

        let bondable = <Label horizontal color={this.props.inmate.IsBondDenied === false ? 'green' : 'red'}>Bond status:<Label.Detail>{this.props.inmate.IsBondDenied === false ? 'Bondable' : 'Not Bondable'}</Label.Detail></Label>
        return(
            <Grid.Column>
                <Card style={{ width: '100%' }} onClick={() => this.props.onClick(this.props.inmate)}>
                <div style={{ position: "relative" }}>
            {displayImage && displayText && (
              <p
                style={{
                  color: "red",
                  position: "absolute",
                  bottom: "0px",
                  zIndex: 999,
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "5px",
                }}
              >
                All persons are presumed innocent until proven guilty
              </p>
            )}
            {displayImage && (
              <Image
                src={
                  this.props.inmate.MugShotFileStream
                    ? "data:image/png;base64, " +
                      this.props.inmate.MugShotFileStream
                    : placeholder
                }
              />
            )}
          </div>
                    <Card.Content>
                        <Card.Header>{ fullName }</Card.Header>
                        <Card.Meta style={{ marginBottom: '10px', marginTop: '5px'}}>
                            <Label horizontal>Booking ID:<Label.Detail>{this.props.inmate.BookingID}</Label.Detail></Label>
                        </Card.Meta>
                        <Card.Description>
                            <Grid columns={2} >
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Booking Date: </strong>{this.props.inmate.BookingDate ? moment.utc(this.props.inmate.BookingDate).format('MM/DD/YYYY') : ''}</div>
                                </Grid.Column>
                                {/* <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>DOB: </strong>{this.props.inmate.DOB ? moment.utc(this.props.inmate.DOB).format('MM/DD/YYYY') : ''}</div>
                                </Grid.Column> */}
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Age: </strong>{this.props.inmate.Age}</div>
                                </Grid.Column>                              
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Height: </strong>{this.props.inmate.Height}</div>
                                </Grid.Column>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Weight: </strong>{this.props.inmate.Weight}</div>
                                </Grid.Column>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Eye Color: </strong>{this.props.inmate.EyeColor}</div>
                                </Grid.Column>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Hair Color: </strong>{this.props.inmate.HairColor}</div>
                                </Grid.Column>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Gender: </strong>{this.props.inmate.Gender}</div>
                                </Grid.Column>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Race: </strong>{this.props.inmate.Race}</div>
                                </Grid.Column>
                            </Grid>
                            <Grid>
                                <Grid.Column style={{ marginBottom: '0px', marginTop:'0.2rem', paddingBottom:'0px', paddingTop:'0.5rem' }}>
                                    <div style={{ fontSize:'13px' }}><strong>Address: </strong><span style={{ fontSize:'12px' }}>{this.props.inmate.Address !== null ? this.props.inmate.Address : ''}</span></div>
                                </Grid.Column>
                            </Grid>
                        </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                        {bondable}
                    </Card.Content>
                </Card>
            </Grid.Column>
        );
    }
 }


// WEBPACK FOOTER //
// ./src/components/InmateGridItem.js